'use strict';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('main.device_config_edit', {
    url: 'device_config_edit/:id',
    template: '<device-config-edit></device-config-edit>'
  });
};



// WEBPACK FOOTER //
// ./public/dev/app/device_config/edit/device_config_edit.routes.js